import { useMutation } from '@tanstack/react-query';

import { DeleteVoucherResponse, deleteVoucher } from '~/services/PromoService';

type DeleteVoucherVars = {
  voucherId: string;
};

export function useDeleteVoucher() {
  return useMutation<DeleteVoucherResponse, Error, DeleteVoucherVars>({
    mutationFn: async ({ voucherId }) => deleteVoucher(voucherId),
  });
}
